const VerificaForm = (form: HTMLFormElement | null) => {
  let verificado = true;

  if (form) {
    Array.from(form.elements).forEach((element) => {
      if (verificado) {
        const input = element as HTMLInputElement;
        if (
          input.value.length < input.minLength ||
          (input.required && input.value.length < 1)
        ) {
          input.setCustomValidity("a");
          input.reportValidity(); //Eu não sei o porque, mas isso funciona

          verificado = false;
        }
      }
    });
  }
  return verificado;
};

export default VerificaForm;
